import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540ee",
      d: "M19.844 14.781a.687.687 0 0 1-.25.938l-8.25 4.812a.69.69 0 0 1-.693 0l-8.25-4.812a.688.688 0 0 1 .693-1.188L11 19.141l7.906-4.61a.69.69 0 0 1 .938.25m-.938-4.375L11 15.016l-7.906-4.61a.687.687 0 0 0-.688 1.188l8.25 4.812a.69.69 0 0 0 .693 0l8.25-4.812a.69.69 0 0 0 .076-1.147.69.69 0 0 0-.769-.04M2.063 6.875a.69.69 0 0 1 .343-.594l8.25-4.812a.69.69 0 0 1 .693 0l8.25 4.812a.687.687 0 0 1 0 1.188l-8.25 4.812a.69.69 0 0 1-.693 0L2.406 7.47a.69.69 0 0 1-.344-.594m2.052 0L11 10.892l6.885-4.017L11 2.858z"
    }, null, -1)
  ]))]))
}
export default { render: render }